'use client'

import type { StoryboardSegment } from '../types'
import SegmentStatusBanner from './SegmentStatusBanner'

export interface SegmentGenerationSectionProps {
  segment: StoryboardSegment;
}

const SegmentGenerationSection: React.FC<SegmentGenerationSectionProps> = ({ segment }) => {
  return (
    <div className="flex flex-col gap-2">
      <SegmentStatusBanner segment={segment} />
    </div>
  )
};

export default SegmentGenerationSection;
